import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendPrice, CustomerProductPrice, PriceService, Pricelist, Product } from 'gung-standard';
import { Observable, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecServiceWorkingOrderService {
  protected baseUrl: string = 'json/colmec-service';

  constructor(
    protected http: HttpClient,
    protected priceService: PriceService
  ) { }

  public getWorkingOrderServicePriceList(servicePriceListId: string): Observable<Pricelist[]> {
    return this.http.get<Pricelist[]>(`${this.baseUrl}/price-list/${servicePriceListId}`);
  }

  public getWorkingOrderServicesByPriceList(servicePriceListId: string): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.baseUrl}/products/${servicePriceListId}`);
  }

  public getWorkingOrderServicePrice(servicePriceListId: string, productId: string): Observable<CustomerProductPrice> {
    return this.http.get<BackendPrice>(`${this.baseUrl}/products/price/${servicePriceListId}/${productId}`).pipe(
      map(backendPrice => {
        return this.mapCustomerProductPrice(backendPrice);
      })
    );
  }

  public getWorkingOrderServicePrices(
    servicePriceListId: string,
    productIds: string[]
  ): Observable<CustomerProductPrice[]> {
    const url = `${this.baseUrl}/products/price/${servicePriceListId}`;
    return this.http.post<Map<string, BackendPrice>>(url, productIds).pipe(
      map(backendPrices => {
        return Object.values(backendPrices).map(backendPrice => {
          return this.mapCustomerProductPrice(backendPrice);
        });
      })
    );
  }

  protected mapCustomerProductPrice(backendPrice: BackendPrice, qty?: number) {
    const priceLevel = this.priceService.getPriceLevel(backendPrice, qty);

    const customerDiscountPercent = priceLevel.discount;

    const customerGrossPrice = priceLevel.price / ((100 - customerDiscountPercent) / 100);
    const customerNetPrice = priceLevel.price;

    const customerProductPrice: CustomerProductPrice = {
      productId: backendPrice.productId,
      customerId: undefined,
      customerDiscountPercent,
      customerGrossPrice: {
        value: customerGrossPrice,
        currencyCode: ''
      },
      customerNetPrice: {
        value: customerNetPrice,
        currencyCode: ''
      },
      customerDiscountAmount: {
        value: customerGrossPrice - customerNetPrice,
        currencyCode: ''
      },
      backendPriceLevel: priceLevel,
      priceFactor: backendPrice.priceFactor,
      backendPrice: backendPrice
    };

    return customerProductPrice;
  }
}
